// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"AS-z","inlineTitle":"BS-z","sponsoredAdsWrapper":"CS-z","marketplaceRecosWrapper":"DS-z"};